import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";

import {useVerifiedPermissions} from "@flexinet/auth-components";
import {rbacActions} from "../../config/rbac/actions.ts";


export const SetupIntentsLayout = () => {

    const {allowedActions} = useVerifiedPermissions()


    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes(rbacActions.ListSetupIntents) ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes(rbacActions.GetSetupIntent) ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/setup-intents'/>
                    )
                }

            >
            </Route>

        </Routes>
    );
};
